import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberExpression'
})

export class NumberExpressionPipe implements PipeTransform {
  transform(value: number, args?: any[]): any {
    if (value >= 1000000) {
      return value / 1000000 + 'M';
    } else {
      return value / 1000.00 + 'K';
    }
  }
}
